"use strict";
const ResourceLoader = require("./resource-loader.js");

module.exports = class NoOpResourceLoader extends ResourceLoader {
  fetch() {
    return null;
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_jsdom@13.2.0@jsdom/lib/jsdom/browser/resources/no-op-resource-loader.js
// module id = rlAG
// module chunks = 0